import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  accordion: {
    paddingTop: "6px",
    marginTop: "75px",
    zIndex: 1001,
    position: "relative",
  },
  dashboardStyle: {
    marginTop: 80,
  },
  subtitleDashboard: {
    padding: "8px",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    marginTop: 30,
    marginBottom: 40,
  },
  textSubtitleDashboard: {
    fontFamily: "MontserratBold",
    fontSize: "50px",
    fontWeight: 700,
    lineHeight: "63px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#00DD9E",
    "@media screen and (max-width:280px)": {
      fontSize: "40px",
    },
  },
  anotherStyle: {
    textAlign: "center",
  },
  questions: {
    fontWeight: "600",
    fontFamily: "Montserrat",
    color: "#00DD9E",
    fontStyle: "normal",
    fontSize: "20px",
    lineHeight: "30px",
  },
  questionsWhite: {
    fontWeight: "600",
    fontFamily: "Montserrat",
    color: theme.palette.text.primary,
    fontStyle: "normal",
    fontSize: "20px",
    lineHeight: "30px",
  },
  answers: {
    fontWeight: "400",
    fontFamily: "Montserrat",
    color: "#333333",
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "24px",
  },

  root: {
    borderBottom: "2px solid #04679C",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  expandedPanel: {
    color: "#04679C",
  },
  MuiAccordionroot: {
    "&.MuiAccordion-root:before": {
      backgroundColor: "white",
    },
  },
  removeCircleOutlineIcon: {
    color: "#04679C",
  },
  addCircleOutlineIcon: {
    color: "#006F56 ",
  },
  link: {
    textDecoration: "none",
  },
  welcomeBanner: {
    display: "block",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "flex-start",
  },
  title: {
    fontFamily: "MontserratExtraBold",
    fontWeight: 800,
    fontSize: 56,
    color: theme.palette.text.secondary,
  },
  registerSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    color: theme.palette.text.tertiary,
    marginLeft: 32,
  },
  passwordField: {
    "&:focus": {
      textDecorationStyle: "none",
    },
    "& .MuiInputBase-input": {
      height: 3,
    },
    "& .MuiOutlinedInput-root": {
      width: 550,
      height: 42,
      borderRadius: 8,
      marginBottom: 0,
      border: "1px solid #E0E0E0",
      fontFamily: "Montserrat",
      fontWeight: 400,
      fontSize: 16,
      color: theme.palette.text.tertiary,
    },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  labels: {
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: 18,
    textAlign: "left",
    color: theme.palette.text.tertiary,

    marginTop: "10px",
    width: "100%",
  },
  termsContainer: {
    width: 544,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    "& .MuiInputBase-input": {
      height: 3,
    },
    height: 32,
    fontFamily: "Montserrat",
    fontWeight: 500,
    textAlign: "left",
    fontSize: 12,
    marginLeft: 8,
  },
  boldText: {
    fontFamily: "MontserratSemiBold",
    color: theme.palette.text.tertiary,
  },
  termsTextBolder: {
    width: 426,
    height: 32,
    fontFamily: "Montserrat",
    fontWeight: 700,
    fontSize: 12,
  },
  singUpOption: {
    fontFamily: "Montserrat",
    marginTop: "10px",
    fontSize: 14,
  },
  passwordHelper: {
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: 12,
    textAlign: "left",
    color: theme.palette.text.tertiary,
    marginTop: 0,
    marginBottom: 16,
    marginLeft: 16,
  },

  icon: {
    color: theme.palette.text.tertiary,
  },
  singUpLink: {
    textDecoration: "none",
    textDecorationLine: "none",
    fontFamily: "MontserratSemiBold",
    fontWeight: 700,
    fontSize: 14,
    color: theme.palette.text.tertiary,
  },
  [theme.breakpoints.down("sm")]: {
    welcomeBanner: {
      display: "none",
    },
    form: {
      alignItems: "center",
    },
    registerSection: {
      alignItems: "center",
      marginLeft: 0,
    },
    textField: {
      width: 400,
    },
    passwordField: {
      "& .MuiOutlinedInput-root": {
        width: 406,
      },
    },
    labels: {
      width: 400,
    },
    termsContainer: {
      width: 400,
    },
    passwordHelper: {
      width: 406,
    },
  },
  [theme.breakpoints.down("xs")]: {
    title: {
      fontSize: 48,
      textAlign: "start",
    },
    textField: {
      width: 252,
    },
    passwordField: {
      "& .MuiOutlinedInput-root": {
        width: 262,
      },
    },
    labels: {
      width: 262,
    },
    passwordHelper: {
      width: 248,
    },
    termsContainer: {
      width: 262,
    },
    termsText: {
      width: 262,
      marginBottom: 24,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  },
  outlinedSelect: {
    backgroundColor: theme.palette.text.tertiary,
  },
  datePickerContainer: {
    width: "100%",

    "& .MuiInputBase-root": {
      padding: theme.spacing(1.5),
    },
  },
  pickerDialogPaper: {
    // eslint-disable-next-line no-multi-str
    "& .MuiTypography-root, \
     & .MuiPickersDay-day, \
     & .MuiPickersCalendarHeader-label, \
     & .MuiPickersCalendarHeader-dayLabel, \
     & .MuiIconButton-root, \
     & .MuiButton-textPrimary, \
     & .MuiDialogActions-root button": {
      color: theme.palette.text.tertiary,
    },
  },

  datePickerInput: {
    width: "100%",

    "& .MuiInputBase-root": {
      borderRadius: 6,
      borderWidth: 1,
      borderStyle: "solid",
      border: "1px solid rgba(255,255,255,0.3)",
      height: 42,
      "&:hover": {
        borderColor:
          theme.palette.mode === "dark"
            ? theme.palette.borderSelect.borderDark
            : "#010C2B",
      },
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": { border: "0 !important" },
      "&:hover fieldset": { border: "0 !important" },
      "&.Mui-focused fieldset": { border: "0 !important" },
    },

    // eslint-disable-next-line no-multi-str
    "& .MuiInput-underline:before, \
     & .MuiInput-underline:hover:not(.Mui-disabled):before, \
     & .MuiInput-underline:after": {
      borderBottom: "0 !important",
    },
  },

  dropdownOption: {
    "& .MuiInputBase-root": {
      borderRadius: 6,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.3)"
          : "rgba(0,0,0,0.3)",
      height: 40,

      display: "flex",
      alignItems: "center",
      padding: "0 11px !important",

      "& fieldset": { border: "0 !important" },
      "&:hover fieldset": { border: "0 !important" },
      "&.Mui-focused fieldset": { border: "0 !important" },

      "&:hover": {
        borderColor:
          theme.palette.mode === "dark"
            ? theme.palette.borderSelect.borderDark
            : "#010C2B",
      },
      "&.Mui-focused": {
        borderColor:
          theme.palette.mode === "dark"
            ? theme.palette.borderSelect.borderDark
            : "#010C2B",
      },

      "& input": {
        padding: 0,
        lineHeight: "40px",
        fontFamily: "Montserrat",
      },

      "& input::placeholder": {
        color:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.6)"
            : "rgba(0,0,0,0.6)",
        opacity: 1,
      },
    },

    "& .MuiSelect-icon": {},
    "& .MuiAutocomplete-clearIndicator": {
      color: theme.palette.text.tertiary,

      "&:hover": {
        color: theme.palette.text.tertiary,
      },
    },
  },

  countryDropdown: {
    width: "100%",
    margin: "0",
    backgroundColor: theme.palette.text.main,
    color: theme.palette.text.secondary,
  },

  checkboxContainer: {
    width: 544,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: 4,
    "& .MuiInputBase-input": {
      height: 3,
    },
    "& .MuiTypography-body1": {
      color: theme.palette.text.tertiary,
      fontSize: 18,
      fontFamily: "MontserratSemiBold",
      fontWeight: 600,
    },

    "& .MuiFormControlLabel-root.Mui-disabled .MuiTypography-root": {
      color: theme.palette.text.disabled,
    },

    "& .MuiCheckbox-root.Mui-disabled": {
      color: theme.palette.text.disabled,
    },

    height: 32,
    textAlign: "left",
    marginLeft: 8,
  },

  [theme.breakpoints.down("sm")]: {
    labels: {
      fontSize: 16,
    },
    checkboxContainer: {
      justifyContent: "center",
      textAlign: "center",
    },
  },
  [theme.breakpoints.down("xs")]: {
    labels: {
      fontSize: 14,
    },
  },

  inputField: {
    "& .MuiInputBase-root": {
      color: theme.palette.text.tertiary,

      borderRadius: 6,
      borderWidth: 1,
      borderStyle: "solid",
      paddingLeft: 10,
      height: 40,
      "&:hover": {
        borderColor:
          theme.palette.mode === "dark"
            ? theme.palette.borderSelect.borderDark
            : "#010C2B",
      },
    },
  },

  outlinedInputProfile: {
    width: "100%",
    borderRadius: 6,
    marginBottom: 6,
    fontFamily: "MontserratSemiBold",
    fontWeight: 400,
    fontSize: 16,
    color: theme.palette.text.tertiary,

    "& .MuiInputBase-input": {
      padding: "10px 12px",
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.main
          : "#E0E0E0",
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
      borderWidth: 1,
    },

    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.main
          : "#E0E0E0",
    },
    "&.Mui-disabled": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.background.box
          : "#F5F5F5",
      color: theme.palette.text.secondary,
      WebkitTextFillColor: theme.palette.text.secondary,
    },
  },

  profileSelect: {
    width: "100%",
    borderRadius: 6,
    marginBottom: 6,
    fontFamily: "MontserratSemiBold",
    fontWeight: 400,
    fontSize: 16,
    color: theme.palette.text.tertiary,
    "& .MuiSelect-iconOutlined": {
      color: theme.palette.text.tertiary,
    },

    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.borderSelect.borderDark,
      },
    },
    "& .MuiInputBase-input": {
      padding: "10px 12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.main
          : "#E0E0E0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
      borderWidth: 1,
    },
  },
  menuItemProfile: {
    fontFamily: "Montserrat",
    fontSize: 15,
    padding: "10px 14px",

    transition: "all 0.2s ease-in-out",
    backgroundColor: "transparent",
    color: theme.palette.text.primary,

    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.08)"
          : "rgba(0, 0, 0, 0.04)",
      color: theme.palette.text.primary,
    },

    "&.Mui-selected": {
      backgroundColor: theme.palette.mode === "dark" ? "#06E89F" : "#041370",
      color: theme.palette.mode === "dark" ? "#041370" : "#FFFFFF",

      "&:hover": {
        backgroundColor: theme.palette.mode === "dark" ? "#06E89F" : "#041370",
        opacity: 0.9,
      },
    },
  },
}));

export default useStyles;
